<template>
  <div class="ourbrand">
    <div
      class="mobile-show"
      style="
             width: 100vw;
             height: calc(100vw * 0.125);
             position:absolute;
             top:0;
             background: url(./img/mobile_header_bg1.jpg) center top  / cover;
             background-repeat: no-repeat;
             "
      ></div>
    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="false"
        :speed="2000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
        >
        <div
          class="slide"
          style="background: url('./img/about_slide01.jpg') center center / cover;"
          ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide02.jpg') center center / cover;"
          ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide03.jpg') center center / cover;"
          ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide04.jpg') center center / cover;"
          ></div>
      </agile>
      <div class="slidetextbg"></div>
      <div class="slidetext tablet-offset">{{$t('body.about_slide')}}</div>
      <div
        style="
               width: 100%;
               height: 133px;
               position: absolute;
               top: 370px;
               background: url(./img/about_overlay.png) center center / cover;
               mix-blend-mode:multiply;
               "
        ></div>
      <div class="container" style="position:absolute;top:0;right:0;">
        <agile
          :autoplay="true"
          :speed="2000"
          :autoplay-speed="5000"
          :fade="true"
          :dots="true"
          :nav-buttons="false"
          style="height:500px;overflow:hidden;"
          @beforeChange="syncslide"
          >
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_vision.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_trust.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_persist.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_determin.png" alt width="48" />
            </div>
          </div>
        </agile>
      </div>
    </div>

    <div class="mobile-unpad">
      <div
        class="container mobile-padding mobile-bg-blue"
        style="text-align:left;margin-bottom:16px; padding-top:32px;"
        >
        <div class="columns">
          <div class="column blue-title" style="padding-bottom:0;">
            <span class="title-size">{{$t('body.aboutus_brand_title1')}}</span>
            <span
              class="title-size mobile-show"
              style="font-weight:900;
                     font-family:AvenirBold;
                     top: -10px;
                     position: relative;"
              >{{$t('body.aboutus_brand_title2')}}</span>
            <span
              class="title-size mobile-hide-inline"
              style="font-weight:900;
                     font-family:AvenirBold;
                     position: relative;"
              >{{$t('body.aboutus_brand_title2')}}</span>
            <div
              class="subtitlebodyblue"
              style="margin-bottom:30px;"
              >{{$t('body.aboutus_brand_p1')}}</div>
          </div>
        </div>
      </div>
      <div
        class="container mobile-padding"
        style="text-align:left;margin-top:16px;margin-bottom:16px;padding-top:32px;"
        >
        <div class="columns bodygrey" style="margin-bottom:50px;text-align:left;">
          <div class="column mobile-column-padding-right mobile-column-padding-bottom">
            <div>{{$t('body.aboutus_brand_p2')}}</div>
          </div>
          <div class="column">
            <div>{{$t('body.aboutus_brand_p3')}}</div>
          </div>
        </div>
      </div>

      <div class="mobile-hide tablet-hide">
        <u-animate-container>
          <u-animate
            name="fadeInUp"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
            >
            <div
              class="container"
              style="height:500px; background:#ddd;margin-bottom:48px;"
              @mouseenter="hilight"
              @mouseleave="hilight"
              >
              <div class="logodefbg hide"></div>
              <div id="logodeftext" class="logodeftext hide">
                <div style="width:50%;">
                  <h1
                    style="color:white;"
                    >{{$t('body.aboutus_logo_def_title')}} {{$t('body.aboutus_logo_def_title2')}}</h1>
                  <p>{{$t('body.aboutus_logo_def01')}}</p>
                  <p>{{$t('body.aboutus_logo_def02')}}</p>

                  <ul style="list-style-type:disc;padding-left:16px;">
                    <li>{{$t('body.aboutus_logo_key1')}}</li>
                    <li>{{$t('body.aboutus_logo_key2')}}</li>
                    <li>{{$t('body.aboutus_logo_key3')}}</li>
                    <li>{{$t('body.aboutus_logo_key4')}}</li>
                  </ul>
                  <p>
                  {{$t('body.aboutus_logo_def03')}}
                  <strong
                    style="color:white;"
                    >{{$t('body.aboutus_logo_def04')}}</strong>
                  {{$t('body.aboutus_logo_def05')}}
                  </p>
                </div>
              </div>

              <agile
                :autoplay="true"
                :speed="2000"
                :autoplay-speed="5000"
                :fade="true"
                :dots="false"
                :nav-buttons="false"
                style="height:500px;overflow:hidden;"
                >
                <!-- <div>sssss</div> -->
                <div style="position:relative;width:100%;height:500px;">
                  <div
                    style="width:400px;margin:auto;position: absolute;
                           top: 50%;
                           left: 50%;
                           transform: translate(-50%,-50%);"
                    >
                    <img src="img/logo.png" alt />
                  </div>
                </div>
                <div style="position:relative;width:100%;height:500px;">
                  <div
                    style="width:400px;margin:auto;position: absolute;
                           top: 50%;
                           left: 50%;
                           transform: translate(-50%,-50%);"
                    >
                    <div
                      id="logodef01"
                      class="container middle-separator line-bottom-right"
                      style="font-size: 44px;
                             color: #58585b;"
                      >{{$t('body.aboutus_logo_bg1')}}</div>
                    <div
                      id="logodef02"
                      class="container middle-separator line-bottom-right"
                      style="font-size: 44px;
                             color: #58585b;"
                      >{{$t('body.aboutus_logo_bg2')}}</div>
                    <div
                      id="logodef03"
                      class="container middle-separator line-bottom-right"
                      style="font-size: 44px;
                             color: #58585b;"
                      >{{$t('body.aboutus_logo_bg3')}}</div>
                  </div>
                </div>
              </agile>
            </div>
          </u-animate>
        </u-animate-container>
      </div>

      <div class="tablet-show">
        <div style="position:relative;width:100%;height:390px;background:#ddd;">
          <div
            style="width:100%;margin:auto;position: absolute;
                   top: 10%;
                   left: 50%;
                   transform: translate(-50%,0);"
            >
            <img src="img/logo.png" alt />
          </div>
            <div style="position:relative;width:100%;height:390px;">
              <div
                style="width:400px;margin:auto;position: absolute;
                       top: 28%;
                       left: 50%;
                       transform: translate(-50%,0) scale(0.6);"
                >
                <div
                  id="logodef01"
                  class="container middle-separator line-bottom-right"
                  style="font-size: 44px;
                             color: #58585b;"
                  >{{$t('body.aboutus_logo_bg1')}}</div>
                <div
                  id="logodef02"
                  class="container middle-separator line-bottom-right"
                  style="font-size: 44px;
                             color: #58585b;"
                  >{{$t('body.aboutus_logo_bg2')}}</div>
                <div
                  id="logodef03"
                  class="container middle-separator line-bottom-right"
                  style="font-size: 44px;
                             color: #58585b;"
                  >{{$t('body.aboutus_logo_bg3')}}</div>
              </div>
            </div>
        </div>

        <div>
          <div
            class="mobile-padding"
            style="text-align:left;padding-top: 32px;padding-bottom: 48px;"
            >
            <div class="blue-title">
              <span>{{$t('body.aboutus_logo_def_title')}}&nbsp;</span>
              <span
                style="font-weight:900;font-family:AvenirBold;"
                >{{$t('body.aboutus_logo_def_title2')}}</span>
            </div>
            <div style="color:#6d6e70;">
              <p style="text-align:left;">{{$t('body.aboutus_logo_def01')}}</p>
              <p style="text-align:left;">{{$t('body.aboutus_logo_def02')}}</p>

              <ul style="list-style-type:disc;padding-left:16px;">
                <li>{{$t('body.aboutus_logo_key1')}}</li>
                <li>{{$t('body.aboutus_logo_key2')}}</li>
                <li>{{$t('body.aboutus_logo_key3')}}</li>
                <li>{{$t('body.aboutus_logo_key4')}}</li>
              </ul>
              <p style="text-align:left;">
              {{$t('body.aboutus_logo_def03')}}
              <strong>{{$t('body.aboutus_logo_def04')}}</strong>
              {{$t('body.aboutus_logo_def05')}}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container mobile-bg-blue">
        <div class="columns">
          <div
            class="column mobile-padding"
            style="padding-top:32px; padding-bottom:13px; font-size:48px;"
            >
            <div
              id="divider01"
              class="container middle-separator2 line-bottom-right2 mobile-hide"
              style="font-size: 18px;
                     margin-top:60px;
                     margin-bottom:60px;
                     color: #aaa;"
              >
              <div 
              v-if="this.$i18n.locale == 'cn'"
              style="font-size:28px;"
              >
              BRAND POSITIONING
              </div>
                <div
                  v-if="this.$i18n.locale == 'en'"
                  >
                <img  src="img/chinese_positioning.png" alt width="190" />
              </div>
            </div>
              <div class="blue-title">
                <span>{{$t('body.aboutus_brand_title1')}}</span>
                <br class="mobile-show" />
                <span
                  class="mobile-show"
                  style="font-weight:900;font-family:AvenirBold;position:relative;top:-10px;"
                  >{{$t('body.aboutus_brand_title3')}}</span>
                <span
                  class="mobile-hide-inline"
                  style="font-weight:900;font-family:AvenirBold;position:relative;"
                  >{{$t('body.aboutus_brand_title3')}}</span>
              </div>
              <div
                class="subtitlebodyblue"
                style="margin-bottom:30px;"
                >{{$t('body.aboutus_brand_p4')}}</div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="columns">
          <div @mouseenter="hilightTable" @mouseleave="hilightTable" class="column hilight-table">
            <div>
              <div class="big-digit">1</div>
              <div>
                <span>{{$t('body.aboutus_logo_purpose1_1')}}</span>
                <span class="hilighttext">{{$t('body.aboutus_logo_purpose1_2')}}</span>
              </div>
            </div>
          </div>
          <div
            @mouseenter="hilightTable"
            @mouseleave="hilightTable"
            class="column hilight-table mobile-show"
            >
            <div>
              <div class="big-digit">2</div>
              <div>
                <span>{{$t('body.aboutus_logo_purpose2_1')}}</span>
                <span class="hilighttext">{{$t('body.aboutus_logo_purpose2_2')}}</span>
                <span>{{$t('body.aboutus_logo_purpose2_3')}}</span>
                <span class="hilighttext">{{$t('body.aboutus_logo_purpose2_4')}}</span>
              </div>
            </div>
          </div>
          <div @mouseenter="hilightTable" @mouseleave="hilightTable" class="column hilight-table">
            <div>
              <div class="big-digit">3</div>
              <div>
                <span>{{$t('body.aboutus_logo_purpose3_1')}}</span>
                <span class="hilighttext">{{$t('body.aboutus_logo_purpose3_2')}}</span>
                <span>{{$t('body.aboutus_logo_purpose3_3')}}</span>
                <span 
              v-if="this.$i18n.locale == 'cn'"
                class="hilighttext">{{$t('body.aboutus_logo_purpose3_4')}}</span>
                <br />
                <span 
              v-if="this.$i18n.locale == 'en'"
                class="hilighttext">{{$t('body.aboutus_logo_purpose3_4')}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="columns" style="margin-bottom:48px;">
          <div
            @mouseenter="hilightTable"
            @mouseleave="hilightTable"
            class="column hilight-table mobile-hide"
            >
            <div>
              <div class="big-digit">2</div>
              <div>
                <span>{{$t('body.aboutus_logo_purpose2_1')}}</span>
                <span class="hilighttext">{{$t('body.aboutus_logo_purpose2_2')}}</span>
                <span>{{$t('body.aboutus_logo_purpose2_3')}}</span>
                <span class="hilighttext">{{$t('body.aboutus_logo_purpose2_4')}}</span>
              </div>
            </div>
          </div>
          <div
            @mouseenter="hilightTable"
            @mouseleave="hilightTable"
            class="column hilight-table mobile-extend"
            >
            <div>
              <div class="big-digit">4</div>
              <div>
                <span>{{$t('body.aboutus_logo_purpose4_1')}}</span>
                <span class="hilighttext">{{$t('body.aboutus_logo_purpose4_2')}}</span>
                <span>{{$t('body.aboutus_logo_purpose4_3')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container" style="text-align:left;margin-bottom:16px;">
        <div
          id="divider02"
          class="container middle-separator2 line-bottom-right2 mobile-hide"
          style="font-size: 18px;
                 margin-top:60px;
                 margin-bottom:60px;
                 color: #aaa;"
          >
              <div 
              v-if="this.$i18n.locale == 'cn'"
              style="font-size:28px;"
              >
              BRAND CHARACTER
              </div>
                <div
                  v-if="this.$i18n.locale == 'en'"
                  >
          <img src="img/chinese_style.png" alt width="163" />
              </div>
        </div>
          <div class="columns">
            <div class="column blue-title mobile-padding" style="padding-bottom:0;">
              <span>{{$t('body.aboutus_brand_title4')}}</span>
              <br class="mobile-show" />
              <span
                class="mobile-show"
                style="font-weight:900;font-family:AvenirBold;position:relative;top:-10px;"
                >{{$t('body.aboutus_brand_title5')}}</span>
              <span
                class="mobile-hide-inline"
                style="font-weight:900;font-family:AvenirBold;position:relative;"
                >{{$t('body.aboutus_brand_title5')}}</span>
              <div
                class="subtitlebodyblue mobile-hide"
                style="margin-bottom:30px;"
                >{{$t('body.aboutus_brand_p5')}}</div>
              <div class="mobile-show" style="margin-bottom:30px;">
                <p style="color:#6d6e70; text-align:left;">{{$t('body.aboutus_brand_p5')}}</p>
              </div>
            </div>
          </div>
          <div
            v-if="this.$i18n.locale == 'cn'"
            style="
                   position:relative;
                   width:100%;
                   padding-top:74%;
                   background: url(./img/brand_hex_cn.jpg) center center / cover;
                   "
            >
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 50%;
                     left: 50%;
                     transform: translate(-49.4%, -50.1%);
                     width: 37.2%;
                     height: 57%;
                     background: url(./img/brand_hex_middle.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 7.9%;
                     left: 6%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_topleft_cn.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 7.9%;
                     left: 50.3%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_topright_cn.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 36%;
                     left: 6%;
                     width: 26.1%;
                     height: 28%;
                     background: url(./img/brand_hex_left_cn.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 36%;
                     left: 68.4%;
                     width: 26.1%;
                     height: 28%;
                     background: url(./img/brand_hex_right_cn.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 64%;
                     left: 6%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_bottomleft_cn.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 64%;
                     left: 50.2%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_bottomright_cn.png) center center / cover;
                     "
              ></div>
          </div>
          <div
            v-if="this.$i18n.locale == 'en'"
            style="
                   position:relative;
                   width:100%;
                   padding-top:74%;
                   background: url(./img/brand_hex.jpg) center center / cover;
                   "
            >
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 50%;
                     left: 50%;
                     transform: translate(-49.4%, -50.1%);
                     width: 37.2%;
                     height: 57%;
                     background: url(./img/brand_hex_middle.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 7.9%;
                     left: 6%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_topleft.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 7.9%;
                     left: 50.3%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_topright.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 36%;
                     left: 6%;
                     width: 26.1%;
                     height: 28%;
                     background: url(./img/brand_hex_left.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 36%;
                     left: 68.4%;
                     width: 26.1%;
                     height: 28%;
                     background: url(./img/brand_hex_right.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 64%;
                     left: 6%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_bottomleft.png) center center / cover;
                     "
              ></div>
            <div
              class="brandhex"
              @mouseenter="hilightHex"
              @mouseleave="hilightHex"
              style="
                     position:absolute;
                     top: 64%;
                     left: 50.2%;
                     width: 44.3%;
                     height: 28%;
                     background: url(./img/brand_hex_bottomright.png) center center / cover;
                     "
              ></div>
          </div>
      </div>
    </div>
    <div style="position:relative;top:170px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>
<script>
export default {
  name: "brand",
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
        if  ( this.$i18n.locale == "cn" ){
    document.styleSheets[0].addRule(
      "#logodef01.container.middle-separator.line-bottom-right::after",
      "width: 90px;"
    );
    document.styleSheets[0].addRule(
      "#logodef02.container.middle-separator.line-bottom-right::after",
      "width: 90px;"
    );
    document.styleSheets[0].addRule(
      "#logodef03.container.middle-separator.line-bottom-right::after",
      "width: 90px;"
    );
    document.styleSheets[0].addRule(
      "#divider01.container.middle-separator2.line-bottom-right2::after",
      "width: 280px;"
    );
    document.styleSheets[0].addRule(
      "#divider02.container.middle-separator2.line-bottom-right2::after",
      "width: 270px;"
    );
    } else {
    document.styleSheets[0].addRule(
      "#logodef01.container.middle-separator.line-bottom-right::after",
      "width: 190px;"
    );
    document.styleSheets[0].addRule(
      "#logodef02.container.middle-separator.line-bottom-right::after",
      "width: 280px;"
    );
    document.styleSheets[0].addRule(
      "#logodef03.container.middle-separator.line-bottom-right::after",
      "width: 205px;"
    );
    document.styleSheets[0].addRule(
      "#divider01.container.middle-separator2.line-bottom-right2::after",
      "width: 190px;"
    );
    document.styleSheets[0].addRule(
      "#divider02.container.middle-separator2.line-bottom-right2::after",
      "width: 163px;"
    );
    }

  },
  methods: {
    hilight(e) {
      console.log(e.target.children);
      // let el = e.target.children[0];
      e.target.children[0].classList.toggle("hide");
      e.target.children[1].classList.toggle("hide");
    },
    hilightTable(e) {
      let el = e.target;
      el.classList.toggle("over");
    },
    hilightHex(e) {
      let el = e.target;
      el.classList.toggle("show");
    },
    syncslide() {
      let self = this;
      console.log("syncslide");
      self.$refs.imagecarousel.goToNext();
    }
  }
};
</script>

  <style scoped lang="scss">
  .slide {
    width: 100%;
    height: 400px;
    // background: url("../assets/logo.png");
  }

  // .column {
    //   padding: 0;
  // }

  .slidetextbg {
    width: 500px;
    height: 400px;
    background: linear-gradient(to right, #013d57dd 70%, #013d5700);
    mix-blend-mode: multiply;
    position: absolute;
    top: 0;
    left: 0;
    color: white;
    text-align: justify;
    padding: 24px 200px 0 24px;
    font-size: 20px;
  }

  .slidetext {
    width: 550px;
    height: 400px;
    position: absolute;
    top: 0;
    left: 0;
    color: white;
    text-align: left;
    line-height: 29px;
    padding: 24px 200px 0 24px;
    font-size: 25px;
  }
  .slide-overlay {
    width: calc(1000px - 126px);
    height: inherit;
    font-size: 40px;
    line-height: 1;
    text-align: right;
    color: white;
    border-right: white solid 1px;
    position: relative;
    padding: 0 8px;
    top: 24px;
    // right: -500px;
  }

  .slide-overlay::after {
    content: "";
    display: block;
    width: 4px;
    height: 100px;
    background: white;
    position: absolute;
    padding-right: 4px;
    top: 0;
    right: 0;
  }

  .logodef {
    width: 100%;
    height: inherit;

    color: white;
    position: absolute;
    z-index: 2;
    opacity: 1;
    text-align: left;
    transition: all 100ms ease-in-out;
  }
  .logodef.hide {
    width: 100%;
    height: inherit;

    position: absolute;
    z-index: 2;
    opacity: 0;
    text-align: left;
    transition: all 100ms ease-in-out;
  }
  .logodefbg {
    width: 100%;
    height: inherit;
    background: #005677;
    mix-blend-mode: multiply;
    position: absolute;
    z-index: 2;
    padding: 16px;
    opacity: 1;
    text-align: left;
    transition: all 100ms ease-in-out;
  }
  .logodefbg.hide {
    width: 100%;
    height: inherit;
    background: #005677;
    mix-blend-mode: multiply;
    position: absolute;
    z-index: 2;
    padding: 16px;
    opacity: 0;
    text-align: left;
    transition: all 100ms ease-in-out;
  }

  .logodeftext {
    width: 100%;
    height: inherit;
    color: white;
    position: absolute;
    z-index: 3;
    padding: 16px 0 0 32px;
    opacity: 1;
    text-align: left;
    transition: all 100ms ease-in-out;
    p {
      text-align: left;
    }
  }
  .logodeftext.hide {
    width: 100%;
    height: inherit;
    position: absolute;
    z-index: 3;
    padding: 16px;
    opacity: 0;
    text-align: left;
    transition: all 100ms ease-in-out;
    p {
      text-align: left;
    }
  }

  .middle-separator {
    color: #58585b;
    font-size: 28px;
    padding-bottom: 3px;
    text-align: right;
    line-height: 1.7;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .line-bottom-right {
    border-bottom: 1px solid #58585b;
    position: relative;
  }
  .line-bottom-right:after {
    content: "";
    display: block;
    width: 60px;
    height: 6px;
    background: #58585b;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .middle-separator2 {
    color: #bbbdc0;
    font-size: 28px;
    padding-bottom: 3px;
    text-align: right;
    line-height: 1.7;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .line-bottom-right2 {
    border-bottom: 1px solid #bbbdc0;
    position: relative;
  }
  .line-bottom-right2:after {
    content: "";
    display: block;
    width: 60px;
    height: 8px;
    background: #bbbdc0;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .big-digit {
    font-family: AvenirBold;
    font-size: 90px;
    font-weight: 500;
    line-height: 1;
  }

  .hilight-table {
    height: 250px;
    border-right: none;
    border-left: none;
    border-top: solid #b5d9ea 6px;
    border-bottom: none;
    background: #013d57;
    color: grey;
    padding: 24px;
    font-size: 27.5px;
    line-height: 1.2;
    text-align: left;
    span.hilighttext {
      font-weight: 600;
      color: white;
      transition: all 300ms ease-in-out;
    }
    transition: all 300ms ease-in-out;
  }
  .hilight-table.over {
    background: #013d57;
    span.hilighttext {
      font-weight: 600;
      color: white;
      transition: all 300ms ease-in-out;
    }
    transition: all 300ms ease-in-out;
  }

  .brandhex {
    opacity: 0;
  }
  .brandhex.show {
    opacity: 0;
  }

  .mobile-extend {
    height: 300px;
  }

  @media screen and (min-width: 768px) {
    // .big-digit {
      //   font-size: 120px;
      //   font-weight: 900;
      //   line-height: 1;
    // }

    // .brandhex {
      //   opacity: 0;
      //   transition: opacity 500ms ease-in-out;
    // }
    // .brandhex.show {
      //   opacity: 1;
      //   transition: opacity 500ms ease-in-out;
    // }

    .hilight-table {
      height: 300px;
      border: solid white 4px;
      background: #013d57;
      color: grey;
      padding: 24px;
      font-size: 27.5px;
      line-height: 1.2;
      text-align: left;
      span.hilighttext {
        font-weight: 600;
        color: white;
        transition: all 300ms ease-in-out;
      }
      transition: all 300ms ease-in-out;
    }
    .hilight-table.over {
      background: #013d57;
      span.hilighttext {
        font-weight: 600;
        color: white;
        transition: all 300ms ease-in-out;
      }
      transition: all 300ms ease-in-out;
    }
    .tablet-offset{
      top:30px;
    }
  }
  @media screen and (min-width: 992px) {
    .tablet-offset{
      top:0px;
    }
  }
  @media screen and (min-width: 1024px) {
    .big-digit {
      font-size: 120px;
      font-weight: 900;
      line-height: 1;
    }

    .brandhex {
      opacity: 0;
      transition: opacity 500ms ease-in-out;
    }
    .brandhex.show {
      opacity: 1;
      transition: opacity 500ms ease-in-out;
    }

    .hilight-table {
      height: 300px;
      border: solid white 4px;
      background: #005567;
      color: grey;
      padding: 24px;
      font-size: 36px;
      line-height: 1.2;
      text-align: left;
      span.hilighttext {
        font-weight: 600;
        color: grey;
        transition: all 300ms ease-in-out;
      }
      transition: all 300ms ease-in-out;
    }
    .hilight-table.over {
      background: #013d57;
      span.hilighttext {
        color: white;
        transition: all 300ms ease-in-out;
      }
      transition: all 300ms ease-in-out;
    }
  }
  </style>
